"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserUpdateType;
(function (UserUpdateType) {
    UserUpdateType[UserUpdateType["userProfile"] = 0] = "userProfile";
    UserUpdateType[UserUpdateType["userSetting"] = 1] = "userSetting";
})(UserUpdateType = exports.UserUpdateType || (exports.UserUpdateType = {}));
